export interface AttachmentFile {
    ID?: string | number | null;
    URL: string;
    Name: string;
    Size: number;
    Extension: string;
    CreatedAt: number;
    url: string;
    file_name: string;
    size: number;
    format: string;
    blob?: Blob;
    type?: string;
    visibility?: string;
}

type AttachmentLike = Partial<AttachmentFile> | null | undefined;

const getMediaFilesBaseUrl = () => new URL('/api/media/files/', window.location.origin).toString();

const getAttachmentPathSuffix = (attachmentUrl: string = ''): string => {
    if (!attachmentUrl) {
        return '';
    }

    try {
        const parsedUrl = new URL(attachmentUrl, window.location.origin);
        const normalizedPath = parsedUrl.pathname || '';
        const matches = normalizedPath.match(/\/(?:api\/media\/)?files\/(.+)$/);
        return matches?.[1] || '';
    } catch (error) {
        const normalizedUrl = attachmentUrl.replace(window.location.origin, '');
        const matches = normalizedUrl.match(/\/(?:api\/media\/)?files\/(.+)$/);
        return matches?.[1] || '';
    }
};

export const normalizeAttachmentFile = (attachment: AttachmentLike = null): AttachmentFile => {
    const fallbackTimestamp = Math.floor(Date.now() / 1000);
    const url = attachment?.URL || attachment?.url || '';
    const name = attachment?.Name || attachment?.file_name || '';
    const size = attachment?.Size ?? attachment?.size ?? 0;
    const extension = attachment?.Extension || attachment?.format || '';
    const createdAt = attachment?.CreatedAt ?? fallbackTimestamp;

    return {
        ID: attachment?.ID || null,
        URL: url,
        Name: name,
        Size: size,
        Extension: extension,
        CreatedAt: createdAt,
        url: attachment?.url || url,
        file_name: attachment?.file_name || name,
        size: attachment?.size ?? size,
        format: attachment?.format || extension,
        blob: attachment?.blob,
        type: attachment?.type || 'downloadable',
        visibility: attachment?.visibility || 'community',
    };
};

export const getAttachmentDownloadUrl = (attachmentUrl: string = ''): string => {
    if (!attachmentUrl) {
        return attachmentUrl;
    }

    try {
        const attachmentPathSuffix = getAttachmentPathSuffix(attachmentUrl);
        const rewrittenUrl = attachmentPathSuffix ? `${getMediaFilesBaseUrl()}${attachmentPathSuffix}` : attachmentUrl;
        const parsedUrl = new URL(rewrittenUrl, window.location.origin);

        // Preserve encoded URL delimiters so they remain part of the filename instead of changing the request path.
        return parsedUrl.toString();
    } catch (error) {
        const attachmentPathSuffix = getAttachmentPathSuffix(attachmentUrl);
        return attachmentPathSuffix ? `${getMediaFilesBaseUrl()}${attachmentPathSuffix}` : attachmentUrl;
    }
};

export const getAttachmentMetadataUrl = (fileId: string | number | null = ''): string => {
    if (!fileId) {
        return '';
    }

    return `${getMediaFilesBaseUrl()}${encodeURIComponent(String(fileId))}/metadata`;
};
